import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

type Props = ComponentProps<"div"> & {
  type: "discount" | "promotion";
};

const badgeStyles = tv({
  base: "relative justify-self-end md:absolute md:top-2 md:right-2 px-1 uppercase text-[10px]",
  variants: {
    type: {
      discount: "bg-black text-white",
      promotion: "bg-red-700 text-white",
    },
  },
});

export default function CheckoutItemBadge({
  className,
  type,
  ...props
}: Props) {
  return <div className={badgeStyles({ type, className })} {...props} />;
}
